import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Form, Label } from 'semantic-ui-react';

// Import components
import { DatePicker } from '../../../../Shared/DatePicker';

// Import style.
import './Invoice.scss';

const Invoice = ({ dateDue, dateServiceStart, dateServiceEnd, onChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Group>
        <Form.Field width={4}>
          <Label basic className="label-required" style={{ border: 'none' }}>
            {t('billing.invoiceSetup.fields.dueDate')}
          </Label>
          <DatePicker
            required
            data-testid="invoice-due-date"
            placeholder={t('billing.invoiceSetup.fields.dueDate')}
            name={'dateDue'}
            value={dateDue}
            onChange={onChange}
          />
        </Form.Field>
      </Form.Group>

      <Form.Group className={'row-from-to'}>
        <Form.Field width={4}>
          <Label basic style={{ border: 'none' }}>
            {t('billing.invoiceSetup.fields.serviceDatesOptional')}
          </Label>
          <DatePicker
            data-testid="invoice-service-start"
            placeholder={t('billing.invoiceSetup.fields.from')}
            name={'dateServiceStart'}
            value={dateServiceStart}
            onChange={onChange}
            disabled={dateDue ? false : true}
          />
        </Form.Field>
        <Form.Field width={4}>
          <DatePicker
            data-testid="invoice-service-end"
            placeholder={t('billing.invoiceSetup.fields.to')}
            name={'dateServiceEnd'}
            value={dateServiceEnd}
            onChange={onChange}
            disabled={dateServiceStart ? false : true}
            minDate={dateServiceStart}
          />
        </Form.Field>
      </Form.Group>
    </>
  );
};

export default Invoice;
